import { useLayoutEffect, useEffect, useState } from 'react';
import {
    SmallHeightDivider,
    StyledButton,
    MediumHeightDivider,
    SubTitle,
    StyledCheckCircleIcon,
    StyledCancelIcon
} from '../../theme/Styles';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from "react-redux";
import { UpdateAppSubHeaderTitle, ShowGlobalLoading, HideGlobalLoading } from '../../redux/actions/UiActions';
import {
    ButtonContainer,
    ButtonsContainer,
    Container,
    CenterContainer,
} from './styles/ValidateTokenStyles';
import { useParams } from "react-router-dom";
import { paymentValidation } from '../../api/ValidatePayment';
import { useSnackbar } from 'notistack';
import GlobalLoading from '../../components/GlobalLoading/GlobalLoading'
import { getUser, getUserExternal, getValidateToken, registerLoggedUserInServiceBackend, sendCode } from '../../api/Auth';
import LocalStorageService from '../../services/LocalStorageService';
import { useQuery } from 'react-query';
import { cleanStringFromNumbers } from '../../utilities/functions/NumberUtil';
import userLogo from '../../assets/images/user.png'
import { AuthLogin } from '../../redux/actions/AuthActions';

function ValidateToken() {
    const history = useHistory();
    const dispatch = useDispatch();
    let { code } = useParams();
    const { authenticated } = useSelector((state) => state.authReducer);
    const [paymentSuccess, setPaymentSuccess] = useState()
    const [isLoading, setIsLoading] = useState(true);

    const handleTokenValidation = async () => {
        let getCode = await sendCode(code);
        let token = getCode.token;
        try {
            dispatch(ShowGlobalLoading('Validando Token'));
            //This line can be enhancement 
            let userResponse = await getUserExternal({ headers: { Authorization: token, DisableRefreshToken: true } });
            if (userResponse?.success) {
                LocalStorageService.setItem('token', token);
                if (userResponse.payload?.profile_img == null || userResponse.payload?.profile_img === "N/A") {
                    LocalStorageService.setItem('profile_img', userLogo);
                } else {
                    LocalStorageService.setItem('profile_img', userResponse.payload?.profile_img);
                }
                LocalStorageService.setItem('user_cedula', userResponse.payload.citizen_id);
                LocalStorageService.setItem('user_primary_email', userResponse.payload.email);
                const requestData = {
                    id: userResponse.payload.citizen_id,
                    mail: userResponse.payload.email,
                    name: userResponse.payload.name,
                    surname: userResponse.payload.first_last_name,
                    secsurname: userResponse.payload.second_last_name,
                    phone: cleanStringFromNumbers(userResponse.payload.phone),
                    city: userResponse.payload.municipality,
                    created_date:
                    {
                        date: "2019-05-15 04:54:47.000000",
                        timezone_type: 3,
                        timezone: "UTC"
                    }
                }
                await registerLoggedUserInServiceBackend(requestData);
                dispatch(AuthLogin({
                    authenticated: true,
                    profileImg: userResponse?.payload?.profile_img
                }))

                setTimeout(() => {

                    dispatch(HideGlobalLoading());
                    history.push('/app/allServices')
                }, 500);
            } else {
                LocalStorageService.removeItem("token");
                LocalStorageService.removeItem("profile_img");
                LocalStorageService.removeItem("user_cedula");
                LocalStorageService.removeItem("user_primary_email");
                dispatch(HideGlobalLoading());
                history.push('/app/login')
            }
        } catch {
            LocalStorageService.removeItem("token");
            LocalStorageService.removeItem("profile_img");
            LocalStorageService.removeItem("user_cedula");
            LocalStorageService.removeItem("user_primary_email");
            history.push('/app/login')
        }
    }


    useLayoutEffect(() => {
        dispatch(UpdateAppSubHeaderTitle('Verificando Token'))
    }, []);

    useEffect(() => {
        if (!authenticated) {
            handleTokenValidation();
        }
    }, []);

    useEffect(() => {
        if (authenticated) {
            //  history.push('/app/home')
        }
    }, [authenticated]);

    return (
        <Container >

        </Container >
    );
}

export default ValidateToken;